exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);", ""]);

// module
exports.push([module.id, "#app,#app .container,body,html{height:100vh;margin:0}#app{background-image:linear-gradient(198.75865deg,#e46166,#f17458 10.7%,#ef785a 11%,#f47959 11.4%,#f37e5a 12%,#f38154 15.4%,#fba955 31.8%,#fcda81 52%,#e2e5ae 68.7%,#63bbb1)}#app,input{font-family:Open Sans}#app .container{display:grid;grid-template-columns:5fr 1fr}#browser-not-supported{height:100vh;display:flex;flex-flow:row wrap;align-items:center;justify-content:center}.button{background:#0f74bd;padding:15px;color:#fff;border-radius:15px;cursor:pointer}::-webkit-scrollbar{width:10px}::-webkit-scrollbar-track{background:transparent}::-webkit-scrollbar-thumb{background:hsla(0,0%,100%,.3)}::-webkit-scrollbar-thumb:hover{background:hsla(0,0%,100%,.7)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5baac451","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 15
// module chunks = 0